import { render, staticRenderFns } from "./AgencyBalance.vue?vue&type=template&id=70cda0c6&scoped=true&"
import script from "./AgencyBalance.vue?vue&type=script&lang=js&"
export * from "./AgencyBalance.vue?vue&type=script&lang=js&"
import style0 from "./AgencyBalance.vue?vue&type=style&index=0&id=70cda0c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cda0c6",
  null
  
)

export default component.exports